import { useAppContext } from 'AppContext'
import React, { useEffect } from 'react'

import Thumbnail from 'Thumbnail'

const Gallery = () => {

    const { data }  = useAppContext()


    useEffect(() => { console.log(data[data.length - 1])}, [data])

    return (
        <div className={`gallery flex flex-wrap align-start h-full overflow-auto justify-start`}>
            {data.map(obj =>  <Thumbnail {...obj} />)}
        </div>
    )
}

export default Gallery
